import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const ItemWrapper = styled.div<{ isChecked: boolean }>`
    width: 136px;
    height: 112px;
    padding: 2px;
    border-width: 2px;
    border-style: solid;
    border-color: ${({ isChecked }) => isChecked ? COLORS.Outline_Dark : 'transparent'};
    border-radius: 26px;
    background-color: transparent;
    transition: all .25s ease;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 120px;
        height: 104px;
        border-radius: 18px;
    }
`;

export const SBlockContainer = styled(BlockContainer)<{ isSbp: boolean }>`
    position: relative;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    ${({ isSbp }) => isSbp
        ? css`
            padding: 6px 6px 12px;

            &:before {
                content: '';
                position: absolute;
                top: 4px;
                left: 4px;
                right: 4px;
                height: 36px;
                border-radius: 20px;
                background: linear-gradient(17.01deg, #EE7D38 7.46%, #EC5D5D 29.04%, #B244CA 51.1%, #5D70E0 71.24%, #51B5E6 92.34%);
            }

            @media (max-width: ${wideBreakpoints.tablet}) {
                &:before {
                    border-radius: 12px;
                }
            }
        `
        : css`
            padding: 4px 4px 12px;
        `
    };

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const ItemImage = styled.div<{ isSbp?: boolean, isIcon?: boolean }>`
    position: relative;
    width: 100%;
    height: 32px;
    align-items: center;
    margin-bottom: 12px;
    border-radius: 20px;
    background-color: ${COLORS.BgMain};
    z-index: 1;

    ${({ isSbp }) => isSbp
        ? css`
            height: 32px;
            border: 2px solid transparent;
        `
        : css`
            height: 36px;
            border: 2px solid ${COLORS.BgMain};
        `
    };

    img {
        height: 100%;
        margin: 0 auto;
        ${({ isIcon }) => isIcon && css`
            max-height: 17px;
        `}
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: ${({ isSbp }) => isSbp ? '10px' : '12px'}
    }
`;

export const ItemRadio = styled.div`
    flex-wrap: nowrap;
    width: 100%;
    height: 40px;
    padding: 0 8px;
    align-items: center;

    label > input[type="radio"] {
        align-self: center;
    }
`;
